import { ConfigNFe, error99, RetAPI } from "../../Utils/Types"
import { Api } from "../../Utils/api"

export const ConfigService = {

    Save: async (data: ConfigNFe): Promise<RetAPI> => {

        const formData = new FormData()

        if (data.certFile) {
            formData.append("cert_file", data.certFile)
        }

        if (data.id) {
            formData.append("id", data.id.toString() || "0")
        }

        if (data.cscNFCe) {
            formData.append("csc", data.cscNFCe || "")
        }

        if (data.cscIdNFCe) {
            formData.append("csc_id", data.cscIdNFCe)
        }

        if (data.senhaCert) {
            formData.append("password_cert", data.senhaCert)
        }

        formData.append("ambiente", data.ambiente || 'H')
        formData.append("id", data.id.toString())
        const resp = await Api('ConfigNFe/Save', 'post', formData, true)

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        let configNFe: ConfigNFe = {
            id: 0,
            idEmpresa: 0
        }

        if (resp.data.config) {
            configNFe.id = resp.data.config.id
            configNFe.ambiente = resp.data.config.ambiente
            configNFe.idEmpresa = resp.data.config.id_empresa
            configNFe.pathCertificado = resp.data.config.path_certificado
            configNFe.dtCadastro = resp.data.config.dt_cadastro
            configNFe.idUserInsert = resp.data.config.id_user_insert
        }

        return {
            error: false,
            data: configNFe,
            msg: "",
        }

    },

    Find: async (): Promise<RetAPI> => {

        const resp = await Api('ConfigNFe/Find', 'get')

        const configNFe: ConfigNFe = {
            id: 0,
            idEmpresa: 0
        }

        if (!resp.data) {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: configNFe
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.config) {
            configNFe.id = resp.data.config.id
            configNFe.ambiente = resp.data.config.ambiente
            configNFe.idEmpresa = resp.data.config.id_empresa
            configNFe.pathCertificado = resp.data.config.path_certificado
            configNFe.dtCadastro = resp.data.config.dt_cadastro
            configNFe.idUserInsert = resp.data.config.id_user_insert
            configNFe.cscNFCe = resp.data.config.csc_nfce
            configNFe.cscIdNFCe = resp.data.config.csc_id
            configNFe.senhaCert = resp.data.config.senha_certificado
        }

        return {
            error: false,
            data: configNFe
        }
    }
}